import { useFeatureValue } from '@growthbook/growthbook-react'

import { FEATURE_FLAGS } from '~shared/constants'
import { BannerLevel } from '~shared/types'

import { usePublicBanner } from './hooks/usePublicBanner'
import { AppBanner } from './AppBanner'

type PublicBannerFlag = { text: string; level: BannerLevel }

const PUBLIC_BANNER_FLAG_DEFAULT: PublicBannerFlag = { text: '', level: 'info' }

export const PublicBanner = () => {
  const gbBanner = useFeatureValue<PublicBannerFlag>(
    FEATURE_FLAGS.PUBLIC_BANNER,
    PUBLIC_BANNER_FLAG_DEFAULT,
  )
  const { data } = usePublicBanner()

  if (gbBanner.text) {
    return <AppBanner text={gbBanner.text} level={gbBanner.level} />
  }
  return data ? <AppBanner text={data.text} level={data.level} /> : null
}
